// Skuret: recipes, notes and shopping lists. Danish and English; other
// languages fall back to English in t().
const D = (da, en) => ({ da, en });
export const SHED_STRINGS = {
  'menu.shed': D('Skuret', 'The Shed'),
  'home.card_shed_sub': D('Opskrifter, noter og indkøbsliste', 'Recipes, notes and shopping list'),
  'shed.kicker': D('Dit køkken og dine noter', 'Your kitchen and your notes'),
  'shed.intro': D('Opskrifter, noter, indkøbslister og kalender gemmes på din telefon og virker uden net. AI kræver net. Kontosynkronisering er dit valg.', 'Recipes, notes, shopping lists and calendar are saved on your phone and work offline. AI needs a connection. Account sync is your choice.'),
  'shed.memory_only': D('Din browser tillader ikke lokal lagring lige nu (fx privat vindue). Det du laver her gemmes kun, til appen lukkes.', 'Your browser does not allow local storage right now (for example a private window). What you make here is only kept until the app closes.'),
  'shed.loading': D('Åbner Skuret…', 'Opening the Shed…'),
  'shed.back': D('Tilbage til Skuret', 'Back to the Shed'),
  'shed.card_chat': D('Opskrifts-chat', 'Recipe chat'),
  'shed.card_chat_sub': D('Spørg AI om en ret med det du har', 'Ask the AI for a dish with what you have'),
  'shed.card_recipes': D('Mine opskrifter', 'My recipes'),
  'shed.card_recipes_sub': D('Dine egne, også kød og mejeri', 'Your own, meat and dairy too'),
  'shed.card_notes': D('Notesblok', 'Notepad'),
  'shed.card_notes_sub': D('Alt det du vil huske', 'Everything you want to remember'),
  'shed.card_shopping': D('Indkøbsliste', 'Shopping list'),
  'shed.card_shopping_sub': D('Kryds af og se hvad det koster', 'Tick off and see what it costs'),
  'shed.card_sync': D('Gem på min konto', 'Save to my account'),
  'shed.card_calendar': D('Kalender', 'Calendar'),
  'shed.card_calendar_sub': D('Begivenheder, mærkedage og planteplaner', 'Events, anniversaries and plant plans'),
  'shed.sync_on': D('Slået til', 'On'),
  'shed.sync_off': D('Kun på denne telefon', 'Only on this phone'),
  'shed.ai_points': D('AI-point tilbage denne måned', 'AI points left this month'),
  'shed.needs_network': D('Kræver net', 'Needs a connection'),
  'shed.save': D('Gem', 'Save'),
  'shed.saved': D('Gemt', 'Saved'),
  'shed.cancel': D('Annuller', 'Cancel'),
  'shed.delete': D('Slet', 'Delete'),
  'shed.delete_confirm': D('Slet for altid?', 'Delete for good?'),
  'shed.undo': D('Fortryd', 'Undo'),
  'shed.deleted': D('Slettet', 'Deleted'),
  'shed.edit': D('Rediger', 'Edit'),
  'shed.search': D('Søg', 'Search'),
  'shed.empty': D('Her er tomt endnu.', 'Nothing here yet.'),
  'shed.move_up': D('Flyt op', 'Move up'),
  'shed.move_down': D('Flyt ned', 'Move down'),
  'shed.remove_line': D('Fjern linje', 'Remove line'),
  'shed.all': D('Alle', 'All'),
  'recipes.other': D('Andet', 'Other'),

  'shed.recipes_title': D('Mine opskrifter', 'My recipes'),
  'shed.recipe_new': D('Ny opskrift', 'New recipe'),
  'shed.recipe_title': D('Titel', 'Title'),
  'shed.recipe_servings': D('Portioner', 'Servings'),
  'shed.recipe_category': D('Kategori', 'Category'),
  'shed.recipe_ingredients': D('Ingredienser', 'Ingredients'),
  'shed.recipe_ingredient_hint': D('fx 200 g smør', 'e.g. 200 g butter'),
  'shed.recipe_add_ingredient': D('Tilføj ingrediens', 'Add ingredient'),
  'shed.recipe_steps': D('Sådan gør du', 'Method'),
  'shed.recipe_add_step': D('Tilføj trin', 'Add step'),
  'shed.recipe_notes': D('Noter', 'Notes'),
  'shed.recipe_tags': D('Tags (adskilt med komma)', 'Tags (comma separated)'),
  'shed.recipe_title_required': D('Giv opskriften en titel.', 'Give the recipe a title.'),
  'shed.recipe_source_manual': D('Skrevet selv', 'Written by you'),
  'shed.recipe_source_ai_chat': D('Fra opskrifts-chatten', 'From the recipe chat'),
  'shed.recipe_source_ai_structured': D('Fortalt til AI', 'Told to the AI'),
  'shed.recipe_uses': D('Bruger fra haven og naturen', 'Uses from the garden and the wild'),
  'shed.recipe_not_found': D('Opskriften findes ikke længere.', 'This recipe no longer exists.'),
  'shed.ai_title': D('Fortæl det til AI\'en', 'Tell it to the AI'),
  'shed.ai_intro': D('Skriv eller indtal opskriften med dine egne ord (tryk på mikrofonen på tastaturet). AI\'en stiller den op, og du retter til, før du gemmer. Intet gemmes uden dit tryk.', 'Write or dictate the recipe in your own words (tap the microphone on your keyboard). The AI sets it out and you correct it before saving. Nothing is saved until you tap Save.'),
  'shed.ai_placeholder': D('fx Mormors rabarbergrød: et kilo rabarber, 200 g sukker…', 'e.g. Grandma\'s rhubarb compote: a kilo of rhubarb, 200 g sugar…'),
  'shed.ai_button': D('Stil den op for mig', 'Set it out for me'),
  'shed.ai_busy': D('AI\'en læser…', 'The AI is reading…'),
  'shed.ai_done': D('Tjek det hele igennem, og tryk Gem.', 'Check everything and tap Save.'),
  'shed.ai_error': D('AI\'en kunne ikke stille opskriften op. Din tekst er gemt her — prøv igen.', 'The AI could not set out the recipe. Your text is kept here — try again.'),
  'shed.ai_premium': D('At få AI\'en til at stille opskrifter op kræver Premium eller GrowGold.', 'Having the AI set out recipes needs Premium or GrowGold.'),
  'shed.ai_limit': D('Du har brugt dine AI-point denne måned.', 'You have used your AI points this month.'),
  'shed.ai_login': D('Log ind med en konto for at bruge AI.', 'Sign in with an account to use the AI.'),
  'shed.add_to_list': D('Læg i indkøbslisten', 'Add to shopping list'),
  'shed.add_to_list_intro': D('Vælg det du skal købe. Det du selv dyrker, er ikke valgt.', 'Choose what you need to buy. What you grow yourself is not selected.'),
  'shed.from_garden': D('fra haven', 'from the garden'),
  'shed.add_to_list_which': D('Liste', 'List'),
  'shed.add_to_list_confirm': D('Læg i listen', 'Add to list'),
  'shed.added_to_list': D('Lagt i indkøbslisten', 'Added to the shopping list'),

  'shed.notes_title': D('Notesblok', 'Notepad'),
  'shed.note_new': D('Ny note', 'New note'),
  'shed.note_title': D('Titel', 'Title'),
  'shed.note_body': D('Skriv her…', 'Write here…'),
  'shed.note_pin': D('Fastgør øverst', 'Pin to top'),
  'shed.note_unpin': D('Frigør', 'Unpin'),
  'shed.note_untitled': D('Uden titel', 'Untitled'),
  'shed.note_saving': D('Gemmer…', 'Saving…'),

  'shed.shopping_title': D('Indkøbsliste', 'Shopping list'),
  'shed.list_default': D('Indkøb', 'Groceries'),
  'shed.list_new': D('Ny liste', 'New list'),
  'shed.list_name': D('Listens navn', 'List name'),
  'shed.list_rename': D('Omdøb', 'Rename'),
  'shed.list_delete': D('Slet listen', 'Delete list'),
  'shed.list_currency': D('Valuta', 'Currency'),
  'shed.item_name': D('Vare', 'Item'),
  'shed.item_qty': D('Antal', 'Qty'),
  'shed.item_unit': D('Enhed', 'Unit'),
  'shed.item_price': D('Stykpris', 'Unit price'),
  'shed.item_add': D('Tilføj', 'Add'),
  'shed.item_bad_price': D('Prisen kan ikke læses. Skriv fx 12,50.', 'The price cannot be read. Write e.g. 12.50.'),
  'shed.item_bad_qty': D('Antallet kan ikke læses. Skriv fx 2 eller 0,5.', 'The quantity cannot be read. Write e.g. 2 or 0.5.'),
  'shed.item_name_required': D('Skriv hvad du skal købe.', 'Write what you need to buy.'),
  'shed.total_all': D('I alt', 'Total'),
  'shed.total_remaining': D('Mangler', 'Still to buy'),
  'shed.total_basket': D('I kurven', 'In the basket'),
  'shed.total_unpriced': D('uden pris', 'without price'),
  'shed.clear_checked': D('Ryd afkrydsede', 'Clear ticked'),

  'shed.sync_title': D('Gem på min konto', 'Save to my account'),
  'shed.sync_what': D('Hvad gemmes? Dine opskrifter, noter og indkøbslister fra Skuret. Intet andet.', 'What is saved? Your recipes, notes and shopping lists from the Shed. Nothing else.'),
  'shed.sync_why': D('Hvorfor? Så du har en backup, hvis telefonen bliver væk, og så du ser det samme på telefon og computer.', 'Why? So you have a backup if you lose your phone, and see the same on phone and computer.'),
  'shed.sync_where': D('Hvor? På GrowDailys egen server i EU. Vi læser det ikke og bruger det ikke til noget andet.', 'Where? On GrowDaily\'s own server in the EU. We do not read it or use it for anything else.'),
  'shed.sync_stop': D('Du kan altid slå det fra. "Slå fra og slet fra serveren" fjerner det hele fra serveren; kopien på telefonen bliver.', 'You can always turn it off. "Turn off and delete from the server" removes everything from the server; the copy on your phone stays.'),
  'shed.sync_conflict_note': D('Retter du det samme to steder uden net, gemmes begge udgaver — den ene med "(konflikt)" i titlen.', 'If you edit the same thing in two places offline, both versions are kept — one with "(conflict)" in the title.'),
  'shed.sync_enable': D('Slå til og gem på min konto', 'Turn on and save to my account'),
  'shed.sync_disable': D('Slå fra (behold på serveren)', 'Turn off (keep on the server)'),
  'shed.sync_disable_delete': D('Slå fra og slet fra serveren', 'Turn off and delete from the server'),
  'shed.sync_now': D('Gem nu', 'Save now'),
  'shed.sync_guest': D('Det kræver en gratis konto at gemme på serveren.', 'Saving to the server needs a free account.'),
  'shed.sync_create_account': D('Opret konto', 'Create account'),
  'shed.sync_status_saved': D('Gemt på din konto', 'Saved to your account'),
  'shed.sync_status_waiting': D('Venter på net', 'Waiting for a connection'),
  'shed.sync_status_failed': D('Kunne ikke gemme', 'Could not save'),
  'shed.sync_status_syncing': D('Gemmer…', 'Saving…'),
  'shed.sync_status_partial': D('Gemt, men noget kunne ikke komme med (for stort, eller kontoen er fuld med 5.000 ting).', 'Saved, but some items could not be included (too large, or the account is full at 5,000 items).'),
  'shed.sync_status_reset': D('Gem på min konto blev slået fra og slettet fra en anden enhed. Alt er stadig på denne telefon — slå til igen, hvis du vil.', 'Save to my account was turned off and deleted from another device. Everything is still on this phone — switch it on again if you want.'),
  'shed.sync_deleted': D('Slettet fra serveren. Alt er stadig på telefonen.', 'Deleted from the server. Everything is still on the phone.'),
  'shed.conflict': D('(konflikt)', '(conflict)'),

  'shed.make_recipe': D('Lav en opskrift', 'Make a recipe'),
  'shed.save_to_mine': D('Gem i Mine opskrifter', 'Save to My recipes'),
  'shed.saved_to_mine': D('Gemt i Mine opskrifter', 'Saved to My recipes'),
  'recipes.sources_title': D('Hvad vil du lave mad af?', 'What do you want to cook with?'),
  'recipes.tab_garden': D('Min have', 'My garden'),
  'recipes.tab_finds': D('Mine fund', 'My finds'),
  'recipes.tab_catalog': D('Alt spiseligt', 'Everything edible'),
  'recipes.catalog_search': D('Søg i grøntsager, frugt, bær, nødder, urter og svampe', 'Search vegetables, fruit, berries, nuts, herbs and mushrooms'),
  'recipes.group.vegetable': D('Grøntsag', 'Vegetable'),
  'recipes.group.fruit': D('Frugt', 'Fruit'),
  'recipes.group.berry': D('Bær', 'Berry'),
  'recipes.group.nut': D('Nød', 'Nut'),
  'recipes.group.herb': D('Krydderurt', 'Herb'),
  'recipes.group.wild': D('Vild plante', 'Wild plant'),
  'recipes.group.mushroom': D('Svamp', 'Mushroom'),
  'recipes.no_finds': D('Du har ingen fund endnu.', 'You have no finds yet.'),
  'recipes.selected': D('Valgt', 'Selected'),
  'recipes.none_selected': D('Intet valgt — så er det almindelig madlavning med det du køber. Kød og mejeri er velkomment.', 'Nothing selected — ordinary cooking with what you buy. Meat and dairy are welcome.'),
  'recipes.wild_confirm': D('Jeg er helt sikker på artsbestemmelsen af det vilde, jeg har valgt.', 'I am completely sure of the identification of the wild things I selected.'),
  'recipes.wild_note': D('Vilde planter og svampe kan forveksles med giftige. Spis aldrig noget vildt, du ikke er helt sikker på.', 'Wild plants and mushrooms can be confused with poisonous ones. Never eat anything wild you are not completely sure of.'),
  'recipes.lookalike': D('Forveksling', 'Lookalike'),
  'recipes.wild_required': D('Sæt flueben i, at du er helt sikker på artsbestemmelsen.', 'Tick that you are completely sure of the identification.'),
};
